import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import SVGBlog from 'visitor-ui-component-library-icons/icons/SVGBlog';
import { NEUTRAL_600, NEUTRAL_700 } from 'visitor-ui-component-library/constants/WidgetColors';
import { useBrowserWindowContext } from '../../components/BrowserWindowContext';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { handleArticleClick } from '../actions/handleArticleClick';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.ul.withConfig({
  displayName: "ArticlesList__Wrapper",
  componentId: "sc-17o6z9w-0"
})(["display:flex;flex-direction:column;gap:8px;padding:0;list-style:none;margin:0;"]);
const Title = styled.div.withConfig({
  displayName: "ArticlesList__Title",
  componentId: "sc-17o6z9w-1"
})(["font-size:14px;font-weight:600;line-height:18px;"]);
const Subtitle = styled.div.withConfig({
  displayName: "ArticlesList__Subtitle",
  componentId: "sc-17o6z9w-2"
})(["font-size:12px;line-height:18px;color:", ";"], NEUTRAL_600);
const ListItemWrapper = styled.button.withConfig({
  displayName: "ArticlesList__ListItemWrapper",
  componentId: "sc-17o6z9w-3"
})(["padding:8px;color:currentColor;gap:16px;display:flex;justify-content:flex-start;align-items:flex-start;list-style:none;background:none;border:none;width:100%;text-align:left;&:hover{color:", ";}"], ({
  coloring: {
    useDefaultColor,
    accentColor
  }
}) => useDefaultColor ? NEUTRAL_700 : accentColor);
const ArticlesList = ({
  items,
  hideSubtitle = false
}) => {
  const dispatch = useDispatch();
  const {
    browserWindowHeight
  } = useBrowserWindowContext();
  const coloring = useSelector(getColoring);
  const onClick = useCallback(item => {
    const {
      id,
      url
    } = item;
    dispatch(handleArticleClick(id, url, browserWindowHeight));
  }, [dispatch, browserWindowHeight]);
  return /*#__PURE__*/_jsx(Wrapper, {
    children: items.map(article => /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsxs(ListItemWrapper, {
        coloring: coloring,
        onClick: () => onClick(article),
        role: "button",
        children: [/*#__PURE__*/_jsx(SVGBlog, {
          style: {
            fill: 'currentColor',
            marginTop: 2
          },
          width: 16,
          height: 16
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Title, {
            children: article.name
          }), !hideSubtitle && article.knowledgeCategoryName && /*#__PURE__*/_jsx(Subtitle, {
            children: article.knowledgeCategoryName
          })]
        })]
      })
    }, article.id))
  });
};
export default ArticlesList;
ArticlesList.displayName = 'ArticlesList';